import React, { useContext } from 'react';
import { Drawer, useMediaQuery } from '@mui/material';
import { styled, useTheme } from '@mui/material/styles';
import { alpha } from '@mui/material/styles';
import { MenuContext } from '../../context/Menu';
import Logo from './Logo';
import Menu from './Menu';

const MenuContainer = styled('div')(`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  position: relative;
  width: 100%;
  height: 100%;
  flex-wrap: wrap;
`);

const SidebarContainer = styled('div')(({ theme }) => ({
  background: `linear-gradient(180deg, ${theme.palette.background.paper} 0%, ${alpha(
    theme.palette.primary.main,
    0.02,
  )} 100%)`,
  borderRight: `1px solid ${alpha(theme.palette.primary.main, 0.08)}`,
  boxShadow: `4px 0 24px 0 rgba(0, 0, 0, 0.02)`,
  height: '100%',
  width: '100%',
  borderRadius: '16px',
  overflow: 'hidden',
}));

const StyledDrawer = styled(Drawer)(({ theme }) => ({
  '& .MuiDrawer-paper': {
    background: `linear-gradient(180deg, ${theme.palette.background.paper} 0%, ${alpha(
      theme.palette.primary.main,
      0.02,
    )} 100%)`,
    borderRight: `1px solid ${alpha(theme.palette.primary.main, 0.08)}`,
    boxShadow: `8px 0 32px 0 rgba(0, 0, 0, 0.08)`,
  },
}));

function Sidebar() {
  const { menuWidth } = useContext(MenuContext);
  return (
    <SidebarContainer style={{ width: `${menuWidth}px` }}>
      <MenuContainer>
        <div className="w-full">
          <Logo />
          <Menu />
        </div>
      </MenuContainer>
    </SidebarContainer>
  );
}

function ResponsiveSidebar() {
  const theme = useTheme();
  const renderMobileMenu = useMediaQuery(theme.breakpoints.down('md'));
  const { menuWidth, showMobileMenu, setShowMobileMenu } = useContext(MenuContext);
  const onClose = function () {
    setShowMobileMenu?.(false);
  };
  return (
    <>
      {renderMobileMenu && (
        <StyledDrawer anchor={'left'} open={showMobileMenu} onClose={onClose}>
          <div style={{ width: `${menuWidth}px`, height: '100%' }}>
            <Sidebar />
          </div>
        </StyledDrawer>
      )}
      {!renderMobileMenu && <Sidebar />}
    </>
  );
}

export default ResponsiveSidebar;
